import { PersonPostionGroup } from '@aibees/elephant/feature/search-table-people/types';

export function doesWorkHistoryItemHasMoreThanOneRole(
  item: PersonPostionGroup
) {
  return item.profile_positions && item.profile_positions.length > 1;
}
